import { Spinner } from '../../../../../../../shared/frontend/components/presentational/spinner';
import { GuildRankingsTableFrontpage } from './guildRankingsTableFrontpage';

export function RaidRankingsContentFrontpage(props: any) {
  if (!props.rankedGuilds) {
    return <Spinner inline />;
  }
  const loadingSpinner = props.uiLoading ? <Spinner /> : null;
  return (
    <div>
      {loadingSpinner}
      <GuildRankingsTableFrontpage
        style={{
          borderTopLeftRadius: 0,
          borderTopRightRaidus: 0
        }}
        realm={props.realm}
        embedMode={true}
        mode="raid"
        raid={props.raid}
        partition={props.partition}
        partitionOpensAt={props.partitionOpensAt}
        region={props.region}
        guilds={props.rankedGuilds}
        difficulty={props.difficulty}
        title={props.title}
        recent={props.recent}
        setDifficulty={props.setDifficulty}
      />
    </div>
  );
}
